/*
 * Copyright French Prime minister Office/SGMAP/DINSIC/Vitam Program (2019-2022)
 * and the signatories of the "VITAM - Accord du Contributeur" agreement.
 *
 * contact@programmevitam.fr
 *
 * This software is a computer program whose purpose is to implement
 * implement a digital archiving front-office system for the secure and
 * efficient high volumetry VITAM solution.
 *
 * This software is governed by the CeCILL-C license under French law and
 * abiding by the rules of distribution of free software.  You can  use,
 * modify and/ or redistribute the software under the terms of the CeCILL-C
 * license as circulated by CEA, CNRS and INRIA at the following URL
 * "http://www.cecill.info".
 *
 * As a counterpart to the access to the source code and  rights to copy,
 * modify and redistribute granted by the license, users are provided only
 * with a limited warranty  and the software's author,  the holder of the
 * economic rights,  and the successive licensors  have only  limited
 * liability.
 *
 * In this respect, the user's attention is drawn to the risks associated
 * with loading,  using,  modifying and/or developing or reproducing the
 * software by the user in light of its specific status of free software,
 * that may mean  that it is complicated to manipulate,  and  that  also
 * therefore means  that it is reserved for developers  and  experienced
 * professionals having in-depth computer knowledge. Users are therefore
 * encouraged to load and test the software's suitability as regards their
 * requirements in conditions enabling the security of their systems and/or
 * data to be ensured and,  more generally, to use and operate it in the
 * same conditions as regards security.
 *
 * The fact that you are presently reading this means that you have had
 * knowledge of the CeCILL-C license and that you accept its terms.
 */
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import {
  DialogContentWithStateComponent,
  DialogHeaderComponent,
  NextStepComponent,
  PreviousStepComponent,
  SlideToggleComponent,
  VitamUICommonModule,
} from 'vitamui-library';

@Component({
  selector: 'design-system-sample-dialog',
  templateUrl: './sample-dialog.component.html',
  imports: [
    TranslatePipe,
    MatDialogModule,
    DialogHeaderComponent,
    SlideToggleComponent,
    VitamUICommonModule,
    FormsModule,
    NextStepComponent,
    PreviousStepComponent,
    MatRadioModule,
    DialogContentWithStateComponent,
  ],
})
export class SampleDialogComponent {
  private dialogRef = inject<MatDialogRef<SampleDialogComponent>>(MatDialogRef);
  isSmall = inject(MAT_DIALOG_DATA);

  showSteps = true;
  showTitle = true;
  showSubhead = true;
  smallDialog = false;
  radioValue = 1;

  titles = ['Dialog customization', 'Drag & Drop', 'Choose a value', 'Displaying an error', 'Displaying a success message'];

  constructor() {
    const isSmall = this.isSmall;

    this.smallDialog = isSmall;
  }

  toggleSmall($event: boolean) {
    this.smallDialog = $event;
    this.smallDialog ? this.dialogRef.addPanelClass('small') : this.dialogRef.removePanelClass('small');
  }
}
